import AbstractAPI from '@/services/api/AbstractAPI';

export default class WorkTypesApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/work-types');
  }

  get() {
    return this.makeRequest('/', 'get');
  }
}
